import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
 "Washroom deep cleaning & sanitization",
  "Kitchen & cafeteria deep clean",
  "Floor scrubbing & polishing",
  "Carpet shampooing & extraction",
  "Window & glass deep cleaning",
  "Workstation & furniture cleaning",
  "Ceiling & wall cleaning",
  "AC vent & duct cleaning",
  "Basement & parking cleaning",
  "Staircase deep cleaning",
  "Post-construction cleaning",
  "Move-in/move-out cleaning"
];

const steps = [
  {
    number: "01",
    title: "Pre-Cleaning Inspection",
    desc: "Detailed site assessment to identify problem areas and plan the cleaning approach.",
  },
  {
    number: "02",
    title: "Preparation & Setup",
    desc: "Area preparation, furniture protection, and equipment setup for efficient cleaning.",
  },
  {
    number: "03",
    title: "Deep Cleaning Execution",
    desc: "Systematic deep cleaning using specialized equipment and solutions for each surface type.",
  },
  {
    number: "04",
    title: "Quality Inspection",
    desc: "Thorough quality check, client walkthrough, and final touch-ups before handover.",
  },
];

const DeepCleaningServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Deep Cleaning Service Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default DeepCleaningServices;
